export const currency = (value: number, maximumFractionDigits = 0) => new Intl.NumberFormat('fr-FR', {
  style: 'currency', currency: 'EUR', maximumFractionDigits,
}).format(value)

export const number = (value: number) => new Intl.NumberFormat('fr-FR').format(value)

export const date = (value: string, options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', year: 'numeric' }) => {
  const parsed = new Date(value)
  return Number.isNaN(parsed.getTime()) ? value : new Intl.DateTimeFormat('fr-FR', options).format(parsed)
}

export const relativeDate = (value: string) => {
  const delta = new Date(value).getTime() - Date.now()
  const days = Math.round(delta / 86_400_000)
  if (Math.abs(days) < 1) return "aujourd’hui"
  return new Intl.RelativeTimeFormat('fr-FR', { numeric: 'auto' }).format(days, 'day')
}

export const initials = (value: string) => value.split(/\s+/).map((part) => part[0]).join('').slice(0, 2).toUpperCase()
